export default __webpack_public_path__ + "static/media/B.239e5c9d.svg";